import React from 'react';
import Quiz from '../components/Quiz';
import { QuizSettings, QuizResults } from '../types/quiz';

interface QuizPageProps {
  settings: QuizSettings;
  onGameOver: (results: QuizResults) => void;
}

const QuizPage: React.FC<QuizPageProps> = ({ settings, onGameOver }) => {
  return <Quiz settings={settings} onGameOver={onGameOver} />;
};

export default QuizPage;
